import { useEffect, useRef, useState } from 'react'

const useCountdown = (
  initialTimer: number,
  initialPlaying?: boolean,
  expireTime?: () => void
): {
  timer: number
  isPlaying: boolean
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>
} => {
  const milisecond = useRef<number>(0)
  const previous = useRef<number>(0)
  const [timer, setTimer] = useState<number>(initialTimer)
  const [isPlaying, setIsPlaying] = useState<boolean>(!!initialPlaying)

  useEffect(() => {
    if (initialTimer > 0) {
      milisecond.current = initialTimer * 1000
      previous.current = milisecond.current
    }
  }, [initialTimer])

  useEffect(() => {
    if (!isPlaying || milisecond.current <= 0) return

    const effectInitialMs = milisecond.current
    let effectInitialTimeStamp: number | undefined
    let handle: number

    const step = (timestampMs: number) => {
      if (effectInitialTimeStamp === undefined)
        effectInitialTimeStamp = timestampMs
      const elapsed = timestampMs - effectInitialTimeStamp
      milisecond.current = effectInitialMs - elapsed

      if (milisecond.current <= 0) {
        setTimer(0)
        setIsPlaying(false)
        if (expireTime) expireTime()
        cancelAnimationFrame(handle)
      } else {
        const seconds = Math.floor(milisecond.current / 1000)
        const isUpdate = seconds !== Math.floor(previous.current / 1000)
        previous.current = milisecond.current

        if (isUpdate) {
          setTimer(seconds)
        }

        if (isPlaying) {
          handle = window.requestAnimationFrame(step)
        }
      }
    }

    handle = window.requestAnimationFrame(step)

    return () => {
      cancelAnimationFrame(handle)
    }
  }, [isPlaying])

  return {
    timer,
    isPlaying,
    setIsPlaying
  }
}

export default useCountdown
